import React, { useEffect, useState } from "react";
import { Card, Badge } from "../lib/ui";
import api from "../lib/api";

export const rp = (v) => {
  if (v == null) return "Rp 0";
  const n = Math.round(Number(v));
  const abs = Math.abs(n);
  return (n < 0 ? "-Rp " : "Rp ") + abs.toLocaleString("id-ID");
};
export const pct = (v) => (v == null ? "—" : `${Number(v).toLocaleString("id-ID", { maximumFractionDigits: 1 })}%`);

// Last 12 months as YYYY-MM options (newest first).
export function monthOptions(count = 12) {
  const out = [];
  const d = new Date();
  for (let i = 0; i < count; i++) {
    const y = d.getFullYear(), m = d.getMonth() + 1;
    out.push(`${y}-${String(m).padStart(2, "0")}`);
    d.setMonth(d.getMonth() - 1);
  }
  return out;
}

const MONTH_ID = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
export const periodLabel = (p) => {
  if (!p) return "";
  const [y, m] = p.split("-");
  return `${MONTH_ID[parseInt(m, 10) - 1]} ${y}`;
};

export function PeriodPicker({ value, onChange, testid = "finance-period" }) {
  return (
    <select className="cf-input !w-44 !py-2 !text-sm" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
      {monthOptions().map((p) => <option key={p} value={p}>{periodLabel(p)}</option>)}
    </select>
  );
}

// Shared list of active branches (cached per mount).
export function useBranches() {
  const [branches, setBranches] = useState([]);
  useEffect(() => {
    let alive = true;
    api.get("/branches").then(({ data }) => {
      if (!alive) return;
      const list = Array.isArray(data) ? data : (data.rows || data.branches || []);
      setBranches(list.filter((b) => b.active !== false));
    }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return branches;
}

// Standardized branch filter. value="" => Semua Cabang (company-wide). onChange(branch_id|"").
export function BranchFilter({ value, onChange, testid = "finance-branch-filter" }) {
  const branches = useBranches();
  return (
    <select className="cf-input !w-48 !py-2 !text-sm" value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
      <option value="">Semua Cabang</option>
      {branches.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
    </select>
  );
}

export function KpiCard({ icon: Icon, tone = "primary", label, value, sub, testid }) {
  const tones = {
    primary: "bg-primary-light text-primary", success: "bg-success-light text-success-text",
    danger: "bg-danger-light text-danger-text", warn: "bg-warn-light text-warn-text",
    info: "bg-blue-100 text-blue-700", mute: "bg-stone-100 text-stone-600",
  };
  return (
    <Card className="flex items-center gap-3" data-testid={testid}>
      <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${tones[tone]}`}><Icon size={20} /></div>
      <div className="min-w-0">
        <p className="truncate font-heading text-xl font-bold text-ink">{value}</p>
        <p className="text-xs text-ink-mute">{label}</p>
        {sub != null && <p className="text-[11px] text-ink-soft">{sub}</p>}
      </div>
    </Card>
  );
}

const STATUS_TONE = { WITHIN: "success", ABOVE: "danger", BELOW: "warn" };
const STATUS_LABEL = { WITHIN: "Sesuai", ABOVE: "Di Atas", BELOW: "Di Bawah" };
export function BenchmarkBadge({ status }) {
  if (!status) return null;
  return <Badge tone={STATUS_TONE[status]} className="!px-1.5 !py-0.5 !text-[10px]">{STATUS_LABEL[status]}</Badge>;
}
